import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "accordion__dummy"
}

import type { Supporter as SupporterInfo } from '@src/view_models/supporters';
import ContentCard from '@src/components/patterns/ContentCard.vue';
import Accordion from '@src/components/patterns/Accordion.vue';
import AccordionItem from '@src/components/patterns/AccordionItem.vue';

interface Props {
	pageTitle: String;
	supporters: SupporterInfo[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Supporters',
  props: {
    pageTitle: {},
    supporters: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContentCard, null, {
    heading: _withCtx(() => [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t( 'hall_of_fame_title' )), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("p", {
        innerHTML: _ctx.$t( 'hall_of_fame_header_paragraph1' )
      }, null, 8, _hoisted_1),
      _createElementVNode("p", {
        innerHTML: _ctx.$t( 'hall_of_fame_header_paragraph2' )
      }, null, 8, _hoisted_2),
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t( 'hall_of_fame_list_title' )), 1),
      _createVNode(Accordion, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.supporters, (supporter, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (supporter.comment !== '')
                ? (_openBlock(), _createBlock(AccordionItem, {
                    key: 0,
                    name: "supporters"
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(supporter.name), 1)
                    ]),
                    content: _withCtx(() => [
                      _createTextVNode(_toDisplayString(supporter.comment), 1)
                    ]),
                    meta: _withCtx(() => [
                      _createTextVNode(_toDisplayString(supporter.amount), 1)
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createElementBlock("p", _hoisted_3, [
                    _createTextVNode(_toDisplayString(supporter.name) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(supporter.amount), 1)
                  ]))
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})